import { render } from "./ModalConfirmCancelPayment.vue?vue&type=template&id=bf153c34&scoped=true"
import script from "./ModalConfirmCancelPayment.vue?vue&type=script&lang=js"
export * from "./ModalConfirmCancelPayment.vue?vue&type=script&lang=js"

import "./ModalConfirmCancelPayment.vue?vue&type=style&index=0&id=bf153c34&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf153c34"]])

export default __exports__